import { render, staticRenderFns } from "./DeliveryNoteHistory.vue?vue&type=template&id=fc426130&lang=pug&"
import script from "./DeliveryNoteHistory.vue?vue&type=script&lang=ts&"
export * from "./DeliveryNoteHistory.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryNoteHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports